/** JSON replacer for candid / IC values that contain bigint (and Principal-like). */
export function candidJsonReplacer(_key: string, value: unknown): unknown {
	if (typeof value === "bigint") return value.toString();
	if (
		value != null &&
		typeof value === "object" &&
		"toText" in value &&
		typeof (value as { toText: unknown }).toText === "function"
	) {
		try {
			return (value as { toText: () => string }).toText();
		} catch {
			/* fall through */
		}
	}
	return value;
}

/** Bigint-safe string form of a candid error / value for Error messages. */
export function formatCandidError(err: unknown): string {
	if (err == null) return "unknown error";
	if (typeof err === "string") return err;
	if (typeof err === "bigint") return err.toString();
	try {
		return JSON.stringify(err, candidJsonReplacer);
	} catch {
		return String(err);
	}
}

/** Unwrap Motoko ProtocolResult variant from candid. */
export function unwrapResult<T>(result: unknown, label: string): T {
	if (result == null || typeof result !== "object") {
		throw new Error(`${label}: invalid response`);
	}
	const r = result as Record<string, unknown>;
	if ("ok" in r) return r.ok as T;
	if ("err" in r) {
		throw new Error(`${label}: ${formatCandidError(r.err)}`);
	}
	return result as T;
}

export function isOk(result: unknown): boolean {
	return (
		result != null && typeof result === "object" && "ok" in (result as object)
	);
}
